import { Editor } from '@tiptap/react'
import { Flex } from 'antd'

import { FontFamilySelect } from './FontFamilySelect'
import { FontSizeSelect } from './FontSizeSelect'
import { HeadingSelect } from './HeadingSelect'
import { MenuFormatButtons } from './MenuFormatButtons'
import { MenuHighlightButtons } from './MenuHighlightButtons'
import { MenuListButtons } from './MenuListButtons'
import { MenuMediaButtons } from './MenuMediaButtons'
import { MenuTableButtons } from './MenuTableButtons'
import { MenuTextAlignmentButtons } from './MenuTextAlignmentButtons'
import { MenuTextButtons } from './MenuTextButtons'

type Props = {
  editor: Editor
  enableImageModal?: boolean
}

export const MenuBar = ({ editor, enableImageModal }: Props) => {
  return (
    <Flex gap="16px" wrap="wrap" style={{ marginBottom: '10px' }}>
      <HeadingSelect editor={editor} />

      <FontFamilySelect editor={editor} />

      <FontSizeSelect editor={editor} />

      <MenuTextButtons editor={editor} />

      <MenuTextAlignmentButtons editor={editor} />

      <MenuHighlightButtons editor={editor} />

      <MenuListButtons editor={editor} />

      <MenuFormatButtons editor={editor} />

      <MenuTableButtons editor={editor} />

      <MenuMediaButtons editor={editor} enableImageModal={enableImageModal} />
    </Flex>
  )
}
